import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export class SettlemtReportService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }



  getSettlement(pageNumber:any,pageRecords:number,dateFrom:String,dateTo:String,status:String,settlemetBank:string,processedBy:string,senderId:string) {
    var url = "";
    var filter = "";
    if(dateFrom != "" ){
      filter = filter+`&createDate=gte%3D${dateFrom} 00:00:00%24lte%3D${dateFrom} 23:59:59`
    }
    if(dateTo!=""){
      filter = filter+`&settledOn=gte%3D${dateTo} 00:00:00%24lte%3D${dateTo} 23:59:59`
    }
    if(status != "" && status != null){
      filter = filter+`&status=${status}`
    }
    if(processedBy != "" && processedBy != null){
      filter = filter+`&processedBy=${processedBy}`
    }
    if(settlemetBank != "" && settlemetBank != null){
      filter = filter+`&settlementBank=${settlemetBank}`
    }
    if(senderId != "" && senderId != null){
      filter = filter+`&merchantIdentifier=${senderId}`
    }
     url = `${API_URLBLAZE}/transaction/transaction-report/settlement?page_size=${pageRecords}&page_no=${pageNumber}&sort_dir=DESC&sort_column=createDate`+filter;

    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  ExportSettlement(pageNumber:any,pageRecords:number,dateFrom:String,dateTo:String,status:String,settlemetBank:string,processedBy:string,senderId:string) {
    var url = "";
    var filter = "";
    if(dateFrom != "" ){
      filter = filter+`&createDate=gte%3D${dateFrom} 00:00:00%24lte%3D${dateFrom} 23:59:59`
    }
    if(dateTo!=""){
      filter = filter+`&settledOn=gte%3D${dateTo} 00:00:00%24lte%3D${dateTo} 23:59:59`
    }
    if(status != "" && status != null){
      filter = filter+`&status=${status}`
    }
    if(processedBy != "" && processedBy != null){
      filter = filter+`&processedBy=${processedBy}`
    }
    if(settlemetBank != "" && settlemetBank != null){
      filter = filter+`&settlementBank=${settlemetBank}`
    }
    if(senderId != "" && senderId != null){
      filter = filter+`&merchantIdentifier=${senderId}`
    }
     url = `${API_URLBLAZE}/transaction/transaction-report/settlement/export?&sort_dir=DESC&sort_column=createDate`+filter;
      //url = `http://localhost:8083/transaction/transaction-report/settlement/export?sort_dir=DESC&sort_column=createDate${filter}`;

    console.log(url);
    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  getTransactionLogsReport(txnId:string) {  
    let url = `${API_URLBLAZE}/transaction/transact/settlement-logs?txnId=${txnId}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
}


  searchRequest(pageNumber: any, pageRecords: number) {  
      let url = `${API_URLBLAZE}/statement/form?page_size=${pageRecords}&page_no=${pageNumber}+&sort_dir=DESC&sort_column=createdOn`;
      return this.http.get(url).pipe(catchError(this.handleError()));
  }
  
  getAccounts(){
    let url = "";
    url = `${API_URLBLAZE}/statement/report/accounts`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  approveTransaction(settlementTxnId: string, remarks: string): Observable<any> {
    const url = `${API_URLBLAZE}/transaction/transact/settlement/approve`;
    const body = { settlementTxnId, remarks };
    return this.http
      .put(url, body)
      .pipe(catchError(this.handleError()));
  }

  // Function to reject a settlement transaction
  rejectTransaction(settlementTxnId: string, remarks: string): Observable<any> {
    const url = `${API_URLBLAZE}/transaction/transact/settlement/reject`;
    const body = { settlementTxnId, remarks };
    return this.http
      .put(url, body)
      .pipe(catchError(this.handleError()));
  }

  retryTransaction(settlementTxnId: string, remarks: string): Observable<any> {
    const url = `${API_URLBLAZE}/transaction/transact/settlement/retry`;
    const body = { settlementTxnId, remarks };
    return this.http
      .put(url, body)
      .pipe(catchError(this.handleError()));
  }

  getBalance(accountNum:string) {
    let url = `${API_URLBLAZE}/transaction/cma/${accountNum}/balance?idType=accountNumber`;
    return this.http.get(url).pipe(catchError(this.handleError()));
}
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }


}
